import { motion } from "framer-motion";
import { BadgeCheck, Compass, Eye, HeartHandshake, Users } from "lucide-react";
import { IMAGES, PRO_VALUES } from "../../data/content";
import { reveal } from "../../lib/motion";

const ICONS = {
  eye: Eye,
  users: Users,
  "badge-check": BadgeCheck,
  compass: Compass,
  "heart-handshake": HeartHandshake,
};

export const Professionals = ({ onOpenRole }) => {
  return (
    <>
      {/* Seção 10 — Por que ser Profissional AURA */}
      <section
        data-testid="why-professional-section"
        className="bg-creamalt py-16 md:py-24 lg:py-32"
      >
        <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8">
          <motion.p
            {...reveal()}
            className="text-center text-xs font-semibold uppercase tracking-[0.3em] text-gold"
          >
            Para Profissionais
          </motion.p>
          <motion.h2
            {...reveal(0.1)}
            className="mt-4 text-center font-serif text-3xl text-ink sm:text-4xl lg:text-5xl"
          >
            Por que ser uma <em className="italic text-teal">Profissional AURA?</em>
          </motion.h2>
          <div className="mt-14 grid gap-5 sm:grid-cols-2 sm:gap-6 lg:grid-cols-5 lg:gap-8">
            {PRO_VALUES.map((v, i) => {
              const Icon = ICONS[v.icon];
              return (
                <motion.div
                  key={v.title}
                  {...reveal(0.12 * (i + 1))}
                  data-testid={`pro-value-${v.title.toLowerCase()}`}
                  className="rounded-3xl border border-gold-border bg-white p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-gold hover:shadow-[0_20px_60px_rgba(197,160,89,0.12)]"
                >
                  <div className="flex h-12 w-12 items-center justify-center rounded-full bg-teal-light">
                    <Icon className="h-5 w-5 text-teal" />
                  </div>
                  <h3 className="mt-5 font-serif text-xl text-ink">{v.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-mutedink">{v.text}</p>
                </motion.div>
              );
            })}
          </div>
          <motion.div {...reveal()} className="mt-14 text-center">
            <button
              data-testid="professional-cta"
              onClick={() => onOpenRole("PROFESSIONAL")}
              className="rounded-full bg-teal px-9 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-white transition-colors duration-300 hover:bg-teal-hover sm:text-sm"
            >
              Quero ser Profissional AURA
            </button>
          </motion.div>
        </div>
      </section>

      {/* Seção 11 — Para Você, Cliente */}
      <section
        data-testid="client-section"
        className="grain-overlay bg-cream py-16 md:py-24 lg:py-32"
      >
        <div className="relative z-10 mx-auto grid max-w-7xl items-center gap-12 px-5 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8">
          <motion.div {...reveal()} className="order-1">
            <div className="arch-frame overflow-hidden border border-gold-border">
              <img
                src={IMAGES.client}
                alt="Cliente AURA sendo atendida por profissional cristã"
                className="h-[400px] w-full object-cover sm:h-[500px]"
              />
            </div>
          </motion.div>
          <div className="order-2">
            <motion.p
              {...reveal()}
              className="text-xs font-semibold uppercase tracking-[0.3em] text-gold"
            >
              Para Você, Cliente
            </motion.p>
            <motion.h2
              {...reveal(0.1)}
              className="mt-4 font-serif text-3xl leading-tight text-ink sm:text-4xl lg:text-5xl"
            >
              Você não precisa mais{" "}
              <em className="italic text-teal">procurar sozinha.</em>
            </motion.h2>
            <motion.p
              {...reveal(0.2)}
              className="mt-6 text-base leading-relaxed text-mutedink sm:text-lg"
            >
              Sabemos como é difícil encontrar profissionais em quem confiar de
              verdade — alguém que cuide de você, da sua família e dos seus
              sonhos com os mesmos valores que você carrega.
            </motion.p>
            <motion.p
              {...reveal(0.25)}
              className="mt-4 text-base leading-relaxed text-mutedink sm:text-lg"
            >
              No AURA, cada profissional é uma mulher cristã verificada, indicada
              e amada por uma comunidade inteira.
            </motion.p>
            <motion.p
              {...reveal(0.3)}
              className="mt-8 border-l-2 border-gold pl-5 font-serif text-xl italic text-teal sm:text-2xl"
            >
              "Aqui, ser bem atendida não é sorte. É o padrão."
            </motion.p>
            <motion.div {...reveal(0.4)} className="mt-10">
              <button
                data-testid="client-cta"
                onClick={() => onOpenRole("CLIENT")}
                className="rounded-full bg-teal px-9 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-white transition-colors duration-300 hover:bg-teal-hover sm:text-sm"
              >
                Quero ser Cliente AURA
              </button>
            </motion.div>
          </div>
        </div>
      </section>
    </>
  );
};
